var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AclForm',{attrs:{"url":_vm.url,"role":_vm.role,"acls":_vm.acls,"errors":_vm.errors},on:{"onUpdateAcl":_vm.onUpdateAcl,"save":_vm.saveAcl}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf8d15d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/acl/AclCreate.vue
// module id = null
// module chunks = 